import React, {useMemo} from "react";
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import MainPage from "./pages/MainPage";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import {ThemeProvider} from "@emotion/react";
import {createTheme, CssBaseline} from "@mui/material";
import {useRecoilValue} from "recoil";
import {themeAtom} from "./Recoil/Atom/themeAtom";
import {getDesignTokens} from "./theme";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import ko from "date-fns/locale/ko";

function App() {
  const mode = useRecoilValue(themeAtom);
  const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ko}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate replace to="/Home/Login" />} />
            <Route path="Home/Login" element={<Login />} />
            {/* <Route path="Home/Login/:param" element={<Navigate replace to="/Home/Login" />} /> */}

            <Route path="/*" element={<MainPage />} />
          </Routes>
        </BrowserRouter>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
